/*
PAGE-NAV.JS
-
- smooth scroll for in-page navigation links (.c-page-nav)
*/
'use strict';
document.addEventListener('DOMContentLoaded', () => {
    const navLinks = document.querySelectorAll('.c-page-nav a[href^="#"]');
    if (!navLinks.length) return;

    const header = document.querySelector('.l-header');
    // .l-header is a fixed side nav on desktop and only becomes a fixed top bar below this breakpoint (see setting/_variable.scss 'ham')
    const hamMediaQuery = window.matchMedia('(max-width: 992px)');
    const extraGap = 15;

    navLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            const targetId = link.getAttribute('href').slice(1);
            const target = document.getElementById(targetId);
            if (!target) return;

            e.preventDefault();
            const headerHeight = header && hamMediaQuery.matches ? header.offsetHeight : 0;
            const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - extraGap;

            window.scrollTo({
                top: targetTop,
                behavior: 'smooth',
            });
            history.pushState(null, '', `#${targetId}`);
        });
    });
});
